<template>

    <div class="container">

        <app-head title="Properties" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Properties') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.properties.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Type" v-model="form.property_type">
                    <option :value="null">{{ __('Bitte wählen') }}</option>
                    <option :value="k" v-for="(v, k) in propertyTypeOptions">{{ v }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="properties.meta" />
        </div>

        <div class="card">
            <data-table :items="properties.data"
                        :links="properties.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="property in properties.data" :key="property.id">
                    <td>
                        {{ property.id }}
                    </td>
                    <td>
                        <inertia-link class=" stretched-link" :href="route('admin.properties.edit', property)">
                            {{ property.name }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ property.property_type }}
                    </td>
                    <td>
                        <div class="">
                            <span class="small" v-for="propertyOption in property.property_options">
                                {{ propertyOption.content }},
                            </span>
                        </div>
                        <div>
                            {{ property.property_options_count }}
                        </div>
                    </td>
                    <td>
                        <boolean :value="property.filterable" />
                    </td>
                    <td>
                        <boolean :value="property.visible_on_product_page" />
                    </td>
                    <td>
                        {{ property.description | truncateWords }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';
    import Boolean from '@/shared/Admin/Boolean';


    export default {
        props: [
            'filters',
            'properties',
            'propertyTypeOptions',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    property_type: this.filters.property_type,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    property_type: {label: 'Typ', sortable: 'property_type'},
                    property_options: {label: 'Property Options'},
                    filterable: {label: 'Filterbar', sortable: 'filterable'},
                    visible_on_product_page: {label: 'Produktseite', sortable: 'visible_on_product_page'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.properties.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>